import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import store from 'common/store';
import { App } from 'root';
import { ThemeProvider } from '@mui/material';
import { theme } from 'common/constants/theme';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from 'root/auth/auth';
import './config/i18n';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Auth0Provider
    domain="auth.affiliates.digital"
    clientId="aAAdqDUJG0i3OZWNre29KpgLgHH8wQ74"
    authorizationParams={{ redirect_uri: window.location.origin }}
  >
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <AuthProvider>
            <>
              <Toaster />
              <App />
            </>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  </Auth0Provider>
);
